import { HStack, Link, Text, VStack } from '@chakra-ui/react';
import { AppTheme } from '../../theming/valuobject/app-theme.ts';
import { useLingui } from '@lingui/react/macro';
import { useContext } from 'react';
import { LanguageContextProvider } from '../../../app/localization/provider/language-context-provider.ts';
import SelectInput from '../input/select-input.tsx';
import { getLanguageOptions } from '../../../app/localization/valueobject/language.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faGlobe } from '@fortawesome/pro-light-svg-icons';

/**
 * A component that defines the footer of the application.
 * It provides version info and links to legal and contact pages.
 */
export default function PageFooter() {
  const { t } = useLingui();
  const languageContext = useContext(LanguageContextProvider);

  return (
    <HStack
      as={'footer'}
      width={'100%'}
      background={AppTheme.Color.footerGray}
      alignItems={'start'}
      paddingX={{
        base: AppTheme.Size.PX_28,
        md: AppTheme.Size.PX_48,
        lg: AppTheme.Size.PX_72,
        xl: AppTheme.Size.PX_192,
      }}
      paddingY={AppTheme.Size.PX_16}
    >
      <HStack wrap={'wrap'} width={'100%'} gap={AppTheme.Size.PX_16}>
        <Link color={AppTheme.Color.white} fontSize={AppTheme.FontSize.PX_12} href="/lizenzhinweise">
          {t`Lizenzhinweise`}
        </Link>
        <Link
          color={AppTheme.Color.white}
          fontSize={AppTheme.FontSize.PX_12}
          href="https://www.koelnmesse.de/datenschutz/"
        >
          {t`Datenschutz`}
        </Link>
        <Link color={AppTheme.Color.white} fontSize={AppTheme.FontSize.PX_12} href="/agb">
          {t`AGB`}
        </Link>
        <Link
          color={AppTheme.Color.white}
          fontSize={AppTheme.FontSize.PX_12}
          href="https://www.koelnmesse.de/impressum/"
        >
          {t`Impressum`}
        </Link>
        <Link color={AppTheme.Color.white} fontSize={AppTheme.FontSize.PX_12} href="/kontakt">
          {t`Kontakt`}
        </Link>
      </HStack>
      <Text hidden>V{import.meta.env.VITE_APP_VERSION}</Text>
      <VStack paddingLeft={AppTheme.Size.PX_16}>
        <SelectInput
          ariaLabel={t`Sprache auswählen`}
          options={getLanguageOptions()}
          selectedValue={languageContext.currentLanguage}
          onChange={(value) => value && languageContext.changeLanguage(value)}
          leftIcon={<FontAwesomeIcon icon={faGlobe} size={'xs'} />}
          rightIcon={<FontAwesomeIcon icon={faChevronDown} size={'xs'} />}
        ></SelectInput>
      </VStack>
    </HStack>
  );
}
